import React, { memo } from 'react';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { ChevronRight } from 'lucide-react';
export function UniversalChapelPage() {
  return <div className="min-h-screen bg-white" data-id="element-1705">
      {/* Header */}
      <Header variant="solid" data-id="element-1706" />

      {/* Hero Section */}
      <section className="relative py-20 px-8 mt-20" data-id="element-1707">
        <div className="max-w-4xl mx-auto" data-id="element-1708">
          {/* Breadcrumb */}
          <div className="text-sm text-neutral-500 mb-6" data-id="element-1709">
            <a href="/blog" className="hover:text-brand-pink transition-colors" data-id="element-1710">
              News & Events
            </a>
            <span className="mx-2" data-id="element-1711">/</span>
            <span className="text-neutral-900" data-id="element-1712">
              Timeless Love Awaits: A Universal Chapel for Every Couple!
            </span>
          </div>

          {/* Title */}
          <h1 className="font-heading text-4xl lg:text-5xl text-neutral-900 leading-tight mb-6" data-id="element-1713">
            Timeless Love Awaits: A Universal Chapel for Every Couple!
          </h1>

          {/* Featured Image */}
          <div className="relative aspect-[16/9] overflow-hidden bg-gray-300 mb-12" data-id="element-1714">
            <img src="https://crudemomultisite.kinsta.cloud/wine-theme-1/wp-content/uploads/sites/2/2025/11/Peterdsound-House-cellar-Door-Tasting.jpg" alt="Universal Chapel" className="w-full h-full object-cover" data-id="element-1715" />
          </div>

          {/* Content */}
          <article className="max-w-none" data-id="element-1716">
            <p className="text-neutral-600 text-lg leading-relaxed mb-8" data-id="element-1717">
              Nestled amidst breathtaking landscapes, our Peterson House chapel
              offers the ultimate setting for your dream wedding. With its
              charming architecture, sunlit interiors, and serene surroundings,
              this enchanting chapel blends timeless elegance with modern
              comforts. Whether you're envisioning an intimate ceremony or a
              grand celebration, its picturesque ambiance creates the perfect
              backdrop for your special day. From the moment you step inside,
              the warmth and beauty of this space set the tone for memories that
              will last a lifetime.
            </p>

            {/* History Section */}
            <div className="bg-brand-pink/10 border-l-4 border-brand-pink p-8 my-8" data-id="element-1718">
              <p className="text-neutral-700 text-lg leading-relaxed" data-id="element-1719">
                Even though our chapel is a relatively recent addition to the
                Peterson House wedding family, we certainly feel as though it
                has been here since the beginning, having started construction
                in the August 2018 and hosting our first wedding in February of
                2019!
              </p>
            </div>

            <p className="text-neutral-600 text-lg leading-relaxed mb-8" data-id="element-1720">
              The chapel offers so many options for your wedding day! Let's step
              through the doors!
            </p>

            {/* The Perfect First Look */}
            <div className="mb-8" data-id="element-1721">
              <h3 className="font-heading text-2xl text-neutral-900 mb-4" data-id="element-1722">
                The Perfect First Look
              </h3>
              <p className="text-neutral-600 text-lg leading-relaxed" data-id="element-1723">
                The sandstone background along with a lush green hedge line, set
                the scene perfectly for your first look! Walk towards the love
                of your life, tap them on the shoulder, wait for them to turn,
                and see the look you'll both remember for the rest of your life.
              </p>
            </div>

            {/* Ceremony Options */}
            <div className="mb-8" data-id="element-1724">
              <h3 className="font-heading text-2xl text-neutral-900 mb-4" data-id="element-1725">
                The I Do's – Ceremony Options
              </h3>

              <div className="space-y-6" data-id="element-1726">
                <div data-id="element-1727">
                  <h4 className="font-medium text-neutral-900 mb-2" data-id="element-1728">
                    Inside the chapel
                  </h4>
                  <p className="text-neutral-600 text-lg leading-relaxed" data-id="element-1729">
                    Open the doors to the love of your life and enjoy the
                    craftsmanship of the high ceilings, 100-year-old timber
                    beams and timeless aesthetic as you walk down the aisle
                    (along with delightful climate control!)
                  </p>
                </div>

                <div data-id="element-1730">
                  <h4 className="font-medium text-neutral-900 mb-2" data-id="element-1731">
                    Or get hitched on the lawn
                  </h4>
                  <p className="text-neutral-600 text-lg leading-relaxed" data-id="element-1732">
                    Get hitched on the lawn in front of the chapel, with the
                    fountain bubbling away whilst you tie the knot. Using the
                    stunning entryway of the chapel as your "I do" spot, enjoy
                    the sunshine of your beautiful wedding day!
                  </p>
                </div>
              </div>
            </div>

            {/* Post Ceremony */}
            <div className="bg-neutral-50 p-8 my-8" data-id="element-1733">
              <h3 className="font-heading text-2xl text-neutral-900 mb-4" data-id="element-1734">
                Post Ceremony Canape & Cocktail Hour
              </h3>
              <p className="text-neutral-700 text-lg leading-relaxed mb-4" data-id="element-1735">
                You did it! You're married and now you can nip off for your
                forever photos and start the party softly with roving canapes or
                a grazing board for your guests either on our canape deck or
                beside the chapel.
              </p>
              <p className="text-neutral-700 text-lg leading-relaxed" data-id="element-1736">
                Enjoy our beautiful property and hype up your canape hour with
                our lawn games to keep your guests entertained, want more? Add
                on our cocktail package or a Sparkling Wine Tower and get that
                party started!
              </p>
            </div>

            {/* Reception Option */}
            <div className="mb-8" data-id="element-1737">
              <h3 className="font-heading text-2xl text-neutral-900 mb-4" data-id="element-1738">
                Enter Bridal Party! Welcome To Your Reception
              </h3>
              <p className="text-neutral-600 text-lg leading-relaxed mb-4" data-id="element-1739">
                Our stunning chapel now gives you a second reception option!
              </p>
              <p className="text-neutral-600 text-lg leading-relaxed" data-id="element-1740">
                You have had the ceremony of your dreams, canape and cocktail
                hour is done and you are ready to enjoy dinner and kick off your
                married life with your nearest and dearest. Wow your guests with
                this unique space for your reception! Commonly used as the
                ceremony spot, but versatile enough for your reception as well!
                Timeless, elegant and truly beautiful!
              </p>
            </div>

            {/* Call to Action */}
            <div className="bg-brand-pink/5 p-8 my-12 text-center" data-id="element-1741">
              <h3 className="font-heading text-2xl text-neutral-900 mb-4" data-id="element-1742">
                Ready to Plan Your Dream Wedding?
              </h3>
              <p className="text-neutral-700 text-lg leading-relaxed mb-6" data-id="element-1743">
                Discover how our universal chapel can make your special day
                unforgettable. Contact us to schedule a tour and start planning
                your perfect celebration.
              </p>
              <a href="/weddings" className="inline-flex items-center gap-2 bg-brand-pink text-white px-8 py-3 hover:bg-brand-pink/90 transition-colors font-medium rounded-none group" data-id="element-1744">
                Explore Weddings
                <ChevronRight size={16} className="group-hover:translate-x-1 transition-transform duration-200" data-id="element-1745" />
              </a>
            </div>

            {/* Back to Blog */}
            <div className="mt-12" data-id="element-1746">
              <a href="/blog" className="inline-flex items-center gap-2 text-brand-pink hover:text-brand-pink/80 transition-colors font-medium" data-id="element-1747">
                ← Back to News & Events
              </a>
            </div>
          </article>
        </div>
      </section>

      {/* Footer */}
      <Footer data-id="element-1748" />
    </div>;
}